module.exports = __webpack_public_path__ + "static/media/medalha-ouro.913efe8f.png";